import { render, staticRenderFns } from "./RadSettings_Templates.vue?vue&type=template&id=d490c530"
import script from "./RadSettings_Templates.vue?vue&type=script&lang=js"
export * from "./RadSettings_Templates.vue?vue&type=script&lang=js"
import style0 from "./RadSettings_Templates.vue?vue&type=style&index=0&id=d490c530&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports